<template>
    <div style="display: flex; align-items: center; justify-content: center; height: 100%; min-height: 100vh; text-align: center;">
        Our Marketplace is Temporarily Unavailable for Maintenance<br>We’ll be back soon — thank you for your patience!
    </div>
</template>

<script>

</script>

<style scoped>

</style>